module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "banner-sec bg bg-6"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "bg-content"
  }, [_c('h1', {
    staticClass: "size-40 regular hidden-br"
  }, [_vm._v("Encontrá un nuevo grupo de "), _c('br'), _vm._v("clientes habituales")]), _vm._v(" "), _c('p', {
    staticClass: "size-20"
  }, [_vm._v("Hay un mercado sin explotar que está esperando probar tu comida.")]), _vm._v(" "), _c('div', {
    staticClass: "banner-btn"
  }, [_c('a', {
    staticClass: "btn btn-hg btn-primary btn-fill",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#partner"
    }
  }, [_vm._v("COMENZAR")])])])])]), _vm._v(" "), _c('section', {
    staticClass: " section white padding-tb-160 nopad-top-sm"
  }, [_c('div', {
    staticClass: "float-element fe-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 visible-xs visible-sm"
  }, [_c('img', {
    staticClass: "img-section",
    attrs: {
      "src": "/images/backgrounds/bg8.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "box-text sm-centered"
  }, [_c('h1', {
    staticClass: "lato size-34"
  }, [_vm._v("Hacé crecer tu negocio")]), _vm._v(" "), _c('p', {
    staticClass: "size-16 margin-bottom-10"
  }, [_c('span', {
    staticClass: "semibold"
  }, [_vm._v("Atraé nuevos clientes sin esfuerzo.")])]), _vm._v(" "), _c('p', {
    staticClass: "size-16 margin-bottom-20"
  }, [_vm._v("Asociate a "), _c('span', {
    staticClass: "regular"
  }, [_vm._v("andalepide")]), _vm._v(" y conseguí un retorno sustancial a través de grandes pedidos. Generá ingresos adicionales más allá de lo cotidiano.")]), _vm._v(" "), _c('p', {
    staticClass: "size-16 margin-bottom-30"
  }, [_c('span', {
    staticClass: "regular"
  }, [_vm._v("Andalepide")]), _vm._v(" trabaja con restaurantes de alta calidad, servicios de catering, bares y deliverys de Córdoba Capital.")]), _vm._v(" "), _c('div', {
    staticClass: "box-text-btn"
  }, [_c('a', {
    staticClass: "btn btn-fill",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#partner"
    }
  }, [_vm._v("SUMATE COMO PARTNER")])])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "section bg bg-7 no-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "bg-content"
  }, [_c('h1', {
    staticClass: "size-40 regular"
  }, [_vm._v("Maximizá tu producción")]), _vm._v(" "), _c('p', {
    staticClass: "size-18 bold"
  }, [_vm._v("Usa tu cocina al 100% todos los días")]), _vm._v(" "), _c('p', {
    staticClass: "size-20"
  }, [_c('span', {
    staticClass: "semibold"
  }, [_vm._v("Andalepide")]), _vm._v(" aunmenta el flujo de pedidos diarios, incrementando tus ventas. "), _c('br'), _vm._v("Con nuestro servicio, vas a poder planificar con antelación tu producción, organizar tus compras "), _c('br'), _vm._v("y hacer que tu servicio sea más eficiente.")])])])]), _vm._v(" "), _c('section', {
    staticClass: "section white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "head-text"
  }, [_c('h1', {
    staticClass: "lato size-34"
  }, [_vm._v("Con el respaldo de un socio de confianza")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Está en nuestra esencia formar relaciones duraderas y mutuamente beneficiosas con nuestros proveedores. "), _c('br'), _vm._v("Trabajamos para conformar una relación que no sólo brinde beneficios financieros, sino también de exposición y de gestión para su empresa. ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "box-text margin-bottom-40 sm-centered"
  }, [_c('p', {
    staticClass: "size-16"
  }, [_c('span', {
    staticClass: "semibold"
  }, [_vm._v("Pedidos con antelación")]), _c('br'), _vm._v("andalepide envía órdenes con importante tiempo de anticipacion, para que pueda planificar la semana completa, preparar sus recetas minuciosamente y hacer las entregas organizadas.")]), _vm._v(" "), _c('p', {
    staticClass: "size-16"
  }, [_vm._v("Nuestro software está diseñado para que puedas organizar tu cocina, otorgar permisos de usos a tu personal, acceder a información inteligente de todos los pedidos recibidos y llevar una contabilidad sencilla.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "box-text margin-bottom-40 sm-centered"
  }, [_c('p', {
    staticClass: "size-16"
  }, [_c('span', {
    staticClass: "semibold"
  }, [_vm._v("Simplificamos la logística")]), _c('br'), _vm._v("Hemos diseñado un sistema simple, con el cual vas a obtener la informacion exacta de cada pedido. Además, vas a poder coordinar perfectamente todas las entregas, mediante un formulario de pedidos y entregas que establecen claramente el tipo de comida, cantidad de personas, nombre y apellido asignado a cada plato y horario de entrega.")]), _vm._v(" "), _c('p', {
    staticClass: "size-16"
  }, [_vm._v("Asimismo, siempre vas a contar con nuestro servicio de soporte para poder abordar todas tus consultas.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "box-text margin-bottom-40 sm-centered"
  }, [_c('p', {
    staticClass: "size-16"
  }, [_c('span', {
    staticClass: "semibold"
  }, [_vm._v("Soporte contínuo")]), _c('br'), _vm._v("Nuestro está pendiente de tu trabajo y tus dudas, definiremos una persona que atenderá exclusivamente todas tus consultas y te guiará en lo que necesites. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "box-text margin-bottom-40 sm-centered"
  }, [_c('p', {
    staticClass: "size-16"
  }, [_c('span', {
    staticClass: "semibold"
  }, [_vm._v("Exposición")]), _c('br'), _vm._v("Trabajaremos juntos para promocionar tu trabajo en nuestra plataforma y todos nuestros canales de comunicación.")])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "section grey"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "head-text"
  }, [_c('h1', {
    staticClass: "lato size-34"
  }, [_vm._v("Sumate como partner hoy")]), _vm._v(" "), _c('p', {
    staticClass: "size-16 hidden-br"
  }, [_vm._v("Andalepide atrae a empresas con gran número de empleados. Sé parte de la red de entrega "), _c('br'), _vm._v("de comidas en Córdoba Capital. Próximamente más ciudades.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-text centered"
  }, [_c('div', {
    staticClass: "box-text-btn"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-fill",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#partner"
    }
  }, [_vm._v("COMENZÁ AHORA")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "subscribe",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h2', [_vm._v("Suscribite a Andalepide")]), _vm._v(" "), _c('p', {
    staticClass: "size-16"
  }, [_vm._v("¿Estás listo para recibir a diario el menú más variado de comidas de tu ciudad?"), _c('br'), _vm._v("Completa este formulario y un representante nuestro se contactará con vos.")]), _vm._v(" "), _c('form', {
    staticClass: "form modal-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre y Apellido")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Empresa")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("N° de Empleados")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Barrio o Zona")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("E-Mail")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "mail",
      "name": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Teléfono")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-action"
  }, [_c('a', {
    staticClass: "btn-link deco-dotted pull-left",
    attrs: {
      "href": "login.html"
    }
  }, [_vm._v("¿Ya tienes una cuenta?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fill",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("ENVIAR")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "partner",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h2', [_vm._v("Sumate como Partner")]), _vm._v(" "), _c('p', {
    staticClass: "size-16"
  }, [_vm._v("Asociate a Andalepite y hacé crecer tu negocio con un mercado inexplorado en tu ciudad.")]), _vm._v(" "), _c('form', {
    staticClass: "form modal-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Apellido")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre de tu empresa")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de cocina")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Barrio o Zona")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Web o fanpage de Facebook")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("E-Mail")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "mail",
      "name": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Teléfono")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-action"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("ENVIAR")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4434f284"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/static/Partners.vue
// module id = 1125
// module chunks = 5